import type { StatusPillColors } from '../../StatusPill/StatusPill';

import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

import StatusPill from '../../StatusPill/StatusPill';

interface VersionPillProps {
  /**
   * Content object status
   */
  status?: StatusPillColors;
  /**
   * Classes for managing pill order
   */
  orderClasses?: string;
}

const VersionPill = ({
  status = 'blue',
  orderClasses = '',
}: VersionPillProps) => {
  const { t } = useTranslation();

  return (
    <StatusPill
      containerClasses={twMerge(
        'inline-flex items-center justify-center',
        orderClasses,
      )}
      color={status}
      status={t(`ObjectStatus.Status.${status}`)}
      size="sm"
    />
  );
};

export default VersionPill;
